import http from "@/api/http.js";

export function getUsers(params = {}) {
  return http.get("/users/admin_list", { params }).then(res => res.data);
}

export function getUser(uuid) {
  return http.get(`/users/admin_single/${uuid}`).then(res => res.data);
}

export function createUser(data) {
  return http.post("/users/admin_create", data).then(res => res.data);
}

export function updateUser(uuid, data) {
  return http.put(`/users/admin_update/${uuid}`, data).then(res => res.data);
}

export function deleteUser(uuid) {
  return http.delete(`/users/admin_delete/${uuid}`).then(res => res.data);
}

export function toggleEnabled(uuid) {
  return http.put(`/users/admin_toggle_enabled/${uuid}`).then(res => res.data);
}
